import React, { useState, useEffect } from "react";
import { Document, Page, pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const PDFViewer = ({ kfsUrl }) => {
  const [numPages, setNumPages] = useState(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      setWindowHeight(window.innerHeight);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const pageWidth = Math.min(350, windowWidth - 40); // mobile friendly width

  return (
    <div
      style={{
        height: windowHeight * 0.6, // 60% of viewport
        overflowY: "auto",
        border: "1px solid #ccc",
        padding: "5px",
      }}
    >
      <Document
        file={kfsUrl}
        onLoadSuccess={onDocumentLoadSuccess}
        renderMode="canvas"
      >
        {numPages &&
          Array.from(new Array(numPages), (el, index) => (
            <Page
              renderTextLayer={false}
              renderAnnotationLayer={false}
              customTextRenderer={false}
                width={pageWidth}
              key={`page_${index + 1}`}
              className="pdf-page"
              pageNumber={index + 1}
            />
          ))}
      </Document>
    </div>
  );
};

export default PDFViewer;
